import { HttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';

import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from '../environments/environment';
import { loadAppConfig } from './initializers/app-config.initializer';
import { syncDocumentLang } from './initializers/document-lang.initializer';
import { guardIconsFromTranslation } from './initializers/icon-translate-guard.initializer';
import { AppConfigService } from './services/app-config.service';

export function createTranslateLoader(http: HttpClient) {
  let path = './assets/i18n/';
  if (environment.translationsSource === 'server') {
    path = environment.api.host + '/lokalise/';
  }
  return new TranslateHttpLoader(http, path, '.json');
}

// INFO MPS : This file allows you to add providers specific to your application
// without modifying the bootstrap configuration in 'mps.config.ts'.
export const applicationConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: environment.defaultLocale,
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      })
    ),
    provideAppInitializer(() => {
      const initializerFn = loadAppConfig(inject(AppConfigService));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = syncDocumentLang(inject(TranslateService));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = guardIconsFromTranslation();
      return initializerFn();
    }),
  ],
};
